module.exports = __webpack_public_path__ + "img/bubbles.09a97bb2.png";